import React from 'react';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import './ArchivedForms.css';

// Modüler importlar
import { useArchivedForms, useArchivedFormsTable } from './hooks/useArchivedForms';
import PageHeader from './components/PageHeader';
import ArchivedFormsTable from './components/ArchivedFormsTable';
import { RestoreConfirmModal, DeleteConfirmModal } from './components/ConfirmModals';

const ArchivedForms = () => {
  const { t } = useTranslation();
  
  // Hooks
  const {
    forms,
    loading,
    searchText,
    filteredData,
    setSearchText,
    handleRestore,
    handleDelete
  } = useArchivedForms();

  const { getTableConfig } = useArchivedFormsTable();

  // Geri yükleme işlemi için wrapper
  const handleRestoreWithConfirm = (record) => {
    const { showConfirm } = RestoreConfirmModal({
      onConfirm: () => handleRestore(record),
      formTitle: record.title
    });
    showConfirm();
  };

  // Silme işlemi için wrapper
  const handleDeleteWithConfirm = (formId) => {
    const form = forms.find(f => f.id === formId);
    if (form) {
      const { showConfirm } = DeleteConfirmModal({
        onConfirm: () => handleDelete(formId),
        formTitle: form.title
      });
      showConfirm();
    }
  };

  return (
    <div className="archived-forms-container">
      <div style={{ padding: '16px' }}>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <PageHeader
            searchText={searchText}
            onSearchChange={setSearchText}
            totalCount={forms.length}
          />

          <ArchivedFormsTable
            data={filteredData}
            loading={loading}
            onRestore={handleRestoreWithConfirm}
            onDelete={handleDeleteWithConfirm}
            tableConfig={getTableConfig()}
          />
        </Space>
      </div>
    </div>
  );
};

export default ArchivedForms; 